export default __webpack_public_path__ + "static/media/image-night-arcade.a4f25d3b.jpg";